import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { List } from "devextreme-react";
import { Map as LeafletMap, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

function PlaceSearchComponent(props) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [state, setState] = useState({
    location: {
      houseApartment: "",
      roadArea: "",
      landmark: "",
      address: "",
      cityName: "",
      stateName: "",
      countryName: "",
      postalCode: "",
      latitude: "",
      longitude: "",
    },
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      if (
        props?.optionalAutoFillLatitude?.toString()?.trim() !== "" &&
        props?.optionalAutoFillLongitude?.toString()?.trim() !== ""
      ) {
        setTimeout(async () => {
          await getPlaceData(
            "LATLNG",
            "",
            props.optionalAutoFillLatitude,
            props.optionalAutoFillLongitude,
          );
        }, 0);
      } else if (props?.optionalAutoFillAddress?.trim() !== "") {
        setTimeout(async () => {
          await getPlaceData("ADDRESS", props.optionalAutoFillAddress);
        }, 0);
      }
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getPlaceData = async (requestType, address, latitude, longitude) => {
    try {
      let lat,
        lng,
        fullAddress,
        houseApartment,
        roadArea,
        landmark,
        cityName,
        stateName,
        countryName,
        postalCode;

      const mapThrustApiKey = process.env.REACT_APP_MAP_API_KEY;
      if (requestType === "ADDRESS") {
        const res = await fetch(
          `https://maps.mapthrust.io/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${mapThrustApiKey}`,
        );
        const data = await res.json();
        if (!data?.results?.length) return;
        const result = data.results[0];
        lat = result.geometry.location.lat;
        lng = result.geometry.location.lng;
        fullAddress = result.formatted_address;
        const comps = result.address_components || [];
        houseApartment =
          comps.find((c) => c.types?.includes("street_number"))?.long_name ||
          "";
        roadArea =
          comps.find((c) => c.types?.includes("route"))?.long_name || "";
        landmark =
          comps.find((c) => c.types?.includes("sublocality"))?.long_name || "";
        cityName =
          comps.find((c) => c.types?.includes("locality"))?.long_name || "";
        stateName =
          comps.find((c) => c.types?.includes("administrative_area_level_1"))
            ?.long_name || "";
        countryName =
          comps.find((c) => c.types?.includes("country"))?.long_name || "";
        postalCode =
          comps.find((c) => c.types?.includes("postal_code"))?.long_name || "";
      } else if (requestType === "LATLNG") {
        const res = await fetch(
          `https://maps.mapthrust.io/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${mapThrustApiKey}`,
        );
        const data = await res.json();
        if (!data?.results?.length) return;
        const result = data.results[0];
        lat = result.geometry.location.lat;
        lng = result.geometry.location.lng;
        fullAddress = result.formatted_address;
        const comps = result.address_components || [];
        houseApartment =
          comps.find((c) => c.types?.includes("street_number"))?.long_name ||
          "";
        roadArea =
          comps.find((c) => c.types?.includes("route"))?.long_name || "";
        landmark =
          comps.find((c) => c.types?.includes("sublocality"))?.long_name || "";
        cityName =
          comps.find((c) => c.types?.includes("locality"))?.long_name || "";
        stateName =
          comps.find((c) => c.types?.includes("administrative_area_level_1"))
            ?.long_name || "";
        countryName =
          comps.find((c) => c.types?.includes("country"))?.long_name || "";
        postalCode =
          comps.find((c) => c.types?.includes("postal_code"))?.long_name || "";
      } else {
        return;
      }

      setState((prev) => ({
        ...prev,
        location: {
          ...state.location,
          houseApartment,
          roadArea,
          landmark,
          address: fullAddress,
          cityName,
          stateName,
          countryName,
          postalCode,
          latitude: lat,
          longitude: lng,
        },
      }));
      setSearchValue(fullAddress);
    } catch (error) {
      console.log(error);
    }
  };
  const handleAddressInputChange = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      setAddressOptions([]);
      return;
    }
    setIsLoadingOptions(true);
    try {
      const mapThrustApiKey = process.env.REACT_APP_MAP_API_KEY;
      let url = `https://maps.mapthrust.io/maps/api/place/autocomplete/json?input=${encodeURIComponent(inputValue)}&key=${mapThrustApiKey}`;
      const res = await fetch(url);
      const data = await res.json();
      const options = (data?.predictions || []).map((place) => ({
        label: place.description,
        value: { placeId: place.place_id },
      }));
      setAddressOptions(options);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOptions(false);
    }
  };

  const handelOnGooglePlaceChange = async (data) => {
    if (!data) return;
    try {
      const mapThrustApiKey = process.env.REACT_APP_MAP_API_KEY;
      const res = await fetch(
        `https://maps.mapthrust.io/maps/api/place/details/json?place_id=${data.value.placeId}&key=${mapThrustApiKey}`,
      );
      const detail = await res.json();
      const location = detail?.result?.geometry?.location;
      if (location) {
        await getPlaceData("LATLNG", "", location.lat, location.lng);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            <i className="fab fa-google fa-lg" style={{ color: "red" }} />
            {"  "}Search address
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <div style={{ position: "relative" }}>
                  <div style={{ position: "relative" }}>
                    <i
                      className={
                        isLoadingOptions
                          ? "fas fa-spinner fa-spin"
                          : "fas fa-search"
                      }
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "40%",
                        transform: "translateY(-50%) !important",
                        color: "#566e84 !important",
                        fontSize: "14px !important",
                        width: "14px !important",
                        textAlign: "center !important",
                        zIndex: 1,
                        pointerEvents: "none !important",
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search address..."
                      value={searchValue}
                      style={{
                        paddingLeft: "38px",
                        paddingRight: searchValue ? "38px" : "14px",
                        borderRadius: "8px",
                        border: "1px solid #ced4da",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        height: "42px",
                        fontSize: "14px",
                        transition: "border-color 0.2s, box-shadow 0.2s",
                      }}
                      onChange={async (e) => {
                        const val = e.target.value;
                        setSearchValue(val);
                        if (!val) {
                          setAddressOptions([]);
                          setState((prev) => ({
                            ...prev,
                            location: {
                              ...prev.location,
                              address: "",
                              latitude: "",
                              longitude: "",
                              cityName: "",
                              stateName: "",
                              countryName: "",
                              postalCode: "",
                              houseApartment: "",
                              roadArea: "",
                              landmark: "",
                            },
                          }));
                        } else {
                          await handleAddressInputChange(val);
                        }
                      }}
                    />
                    {searchValue && (
                      <button
                        type="button"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#adb5bd",
                          padding: "4px 6px",
                          lineHeight: 1,
                        }}
                        onClick={() => {
                          setSearchValue("");
                          setAddressOptions([]);
                          setState((prev) => ({
                            ...prev,
                            location: {
                              ...prev.location,
                              address: "",
                              latitude: "",
                              longitude: "",
                              cityName: "",
                              stateName: "",
                              countryName: "",
                              postalCode: "",
                              houseApartment: "",
                              roadArea: "",
                              landmark: "",
                            },
                          }));
                        }}
                      >
                        <i
                          className="fas fa-times"
                          style={{ fontSize: "13px" }}
                        />
                      </button>
                    )}
                  </div>
                  {(addressOptions.length > 0 || isLoadingOptions) && (
                    <div
                      style={{
                        position: "absolute",
                        top: "calc(100% + 4px)",
                        left: 0,
                        right: 0,
                        border: "1px solid #dee2e6",
                        borderRadius: "8px",
                        background: "#fff",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                        zIndex: 9999,
                        overflow: "hidden",
                      }}
                    >
                      <List
                        dataSource={addressOptions}
                        keyExpr="label"
                        height={250}
                        noDataText={
                          isLoadingOptions ? "Searching..." : "No results found"
                        }
                        itemRender={(item) => (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                              padding: "6px 2px",
                            }}
                          >
                            <div
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                background: "#fff0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <i
                                className="fas fa-map-marker-alt"
                                style={{ color: "#e74c3c", fontSize: "13px" }}
                              />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  color: "#212529",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.label.split(",")[0]}
                              </div>
                              {item.label.indexOf(",") !== -1 && (
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#6c757d",
                                    marginTop: "1px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item.label
                                    .substring(item.label.indexOf(",") + 1)
                                    .trim()}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        onItemClick={(e) => {
                          handelOnGooglePlaceChange(e.itemData);
                          setSearchValue(e.itemData.label);
                          setAddressOptions([]);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12" style={{ marginTop: "12px" }}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  border: "1px solid #dee2e6",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                  height: "340px",
                  width: "100%",
                  position: "relative",
                }}
              >
                {state.location.address && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "12px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      background: "rgba(255,255,255,0.95)",
                      border: "1px solid #dee2e6",
                      borderRadius: "20px",
                      padding: "6px 14px",
                      fontSize: "12px",
                      color: "#343a40",
                      fontWeight: 500,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      zIndex: 1000,
                      maxWidth: "80%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      pointerEvents: "none",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt"
                      style={{ color: "#e74c3c", marginRight: "6px" }}
                    />
                    {state.location.address}
                  </div>
                )}
                <LeafletMap
                  center={[
                    state.location.latitude || 28.6139,
                    state.location.longitude || 77.209,
                  ]}
                  zoom={16}
                  style={{ height: "100%", width: "100%" }}
                  key={`${state.location.latitude}-${state.location.longitude}`}
                  onClick={async (e) => {
                    const { lat, lng } = e.latlng;
                    try {
                      if (lat > 0 && lng > 0) {
                        await getPlaceData("LATLNG", "", lat, lng);
                      }
                    } catch (error) {}
                  }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  {state.location.latitude && state.location.longitude && (
                    <Marker
                      position={[
                        state.location.latitude,
                        state.location.longitude,
                      ]}
                      icon={L.icon({
                        iconUrl:
                          "https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png",
                        iconSize: [36, 36],
                        iconAnchor: [18, 36],
                        popupAnchor: [0, -36],
                      })}
                    >
                      <Popup>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            maxWidth: "200px",
                          }}
                        >
                          {state.location.address}
                        </div>
                      </Popup>
                    </Marker>
                  )}
                </LeafletMap>
              </div>
              {!state.location.address && (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "6px",
                    fontSize: "11px",
                    color: "#adb5bd",
                  }}
                >
                  <i
                    className="fas fa-mouse-pointer"
                    style={{ marginRight: "4px" }}
                  />
                  Click on the map to pick a location
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Accept"
            className="btn btn-primary btn-sm"
            onClick={() => {
              props.onChange(state.location);
              props.onClose();
            }}
          >
            <i className={`fas fa-check`} />
            &nbsp;Accept
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp;Close
            </span>
          </button>
        </div>
      </Modal>
    </div>
  );
}
export default PlaceSearchComponent;
